import Dropdown from 'react-toolbox/lib/dropdown';
import ValidatedInput from '../../../../../../../common/components/ValidatedInput';
import statesList from '../../../../../../../common/states.json';
import { FormSubHeader } from '../styles';
import { scenarioHandlers } from './utils';
import styles from './styles.css';

export default {
  addressSubHeader: {
    hide: scenarioHandlers.knownCustomer,
    component: FormSubHeader,
    children: 'Enter Home Address',
    readOnly: true,
  },
  streetLine1: {
    component: ValidatedInput,
    hide: scenarioHandlers.knownCustomer,
    label: 'Street Address Line 1',
    validation: [
      {
        checkValid: value => (value || '').length <= 50,
        restrictInput: true,
        events: ['onChange'],
      },
    ],
    maxLength: 50,
    counter: true,
  },
  streetLine2: {
    component: ValidatedInput,
    hide: scenarioHandlers.knownCustomer,
    label: 'Street Address Line 2',
    validation: [
      {
        checkValid: value => (value || '').length <= 50,
        restrictInput: true,
        events: ['onChange'],
      },
    ],
    maxLength: 50,
    counter: true,
  },
  city: {
    component: ValidatedInput,
    hide: scenarioHandlers.knownCustomer,
    label: 'City',
    validation: [
      {
        checkValid: value => (value || '').length <= 40,
        restrictInput: true,
        events: ['onChange'],
      },
    ],
    maxLength: 40,
    counter: true,
  },
  state: {
    component: Dropdown,
    hide: scenarioHandlers.knownCustomer,
    label: 'State',
    source: Object.values(statesList).map(state => ({
      value: state.id,
      label: state.name,
    })),
    required: true,
    className: styles.themedDropdown,
  },
  postalCode: {
    component: ValidatedInput,
    hide: scenarioHandlers.knownCustomer,
    label: 'Zip Code',
    validation: [
      {
        pattern: /^\d{0,5}$/,
        restrictInput: true,
        events: ['onChange'],
      },
      {
        checkValid: value => value.length === 5 || value.length === 0,
        message: 'Please enter a valid zip code.',
        events: ['onBlur'],
      },
    ],
    maxLength: 5,
    counter: true,
  },
  phoneNumber: {
    component: ValidatedInput,
    hide: scenarioHandlers.knownCustomer,
    label: 'Phone Number',
    name: 'phone',
    validation: [
      {
        pattern: /^[\d-]{0,12}$/,
        restrictInput: true,
        events: ['onChange'],
      },
      {
        checkValid: value => {
          const numbersOnly = value.replace(/-/g, '');
          return numbersOnly.length === 10 || numbersOnly.length === 0;
        },
        message: 'Please enter a valid phone number with area code.',
        events: ['onBlur'],
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/RegistrationCard/RegistrationForm/FieldConfig/homeAddress.js